import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { Field, TextOutput } from '../../../../../../Core';
import { withInjectedProps } from '../../../../../../Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from '../../../../../../Layout';
import { PortionMaterialSizeDescriptionField } from '../../../../Components';
import { createSievingPortionLabelSelector, getLabelForPortionState } from '../../../../Helpers';
import MaterialBrokenUpSection from './MaterialBrokenUpSection';
import WashingSection from './WashingSection';

let SievingPreparationPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, namePrefix }) => {
  const stateBeforeSievingPreparation: StateOfMaterial = useSelector(
    createWorksheetSelector!('Masses.StateAfterMassDetermination')
  );
  const isPortionWetBeforeTest = useSelector(
    pipe(
      createWorksheetSelector!('Preparation.StateAfterInitialPreparation'),
      (s: StateOfMaterial) => s !== StateOfMaterial.OvenDry
    )
  );

  const canBreakUp = stateBeforeSievingPreparation === StateOfMaterial.OvenDry;

  const sievingPortionLabel = useSelector(createSievingPortionLabelSelector(createWorksheetSelector!, namePrefix!));

  return (
    <PageSection heading={`${sievingPortionLabel} Preparation`}>
      <ListFieldSection>
        <PortionMaterialSizeDescriptionField />
        <Field
          input={<TextOutput />}
          label="State of Material Prior to Preparation"
          value={getLabelForPortionState(stateBeforeSievingPreparation)}
        />
        {isPortionWetBeforeTest && <Field input={<TextOutput />} label="Portion Wet Mass" name="Masses.WetMass" />}
        <Field input={<TextOutput />} label="Portion Dry Mass" name="Masses.DryMass" />
      </ListFieldSection>
      {canBreakUp && <MaterialBrokenUpSection />}
      <WashingSection />
    </PageSection>
  );
};

SievingPreparationPageSection = withInjectedProps(SievingPreparationPageSection);

export { SievingPreparationPageSection };
export default SievingPreparationPageSection;
